module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_c('v-text-field', {
    staticStyle: {
      "width": "300px",
      "margin-top": "-20px",
      "margin-left": "20px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Quick Search",
      "single-line": "",
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "brown lighten-1",
    attrs: {
      "fab": "",
      "small": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.reloadData()
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    staticStyle: {
      "white-space": "nowrap"
    },
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "search": _vm.search,
      "pagination": _vm.pagination,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_c('th', [_vm._v("ID проверки")]), _vm._v(" "), _c('th', [_vm._v("Сотрудник")]), _vm._v(" "), _c('th', [_vm._v("Размер файла")]), _vm._v(" "), _c('th', [_vm._v("Отправитель")]), _vm._v(" "), _c('th', [_vm._v("Получено от")]), _vm._v(" "), _c('th', [_vm._v("DKIM")]), _vm._v(" "), _c('th', [_vm._v("SPF")]), _vm._v(" "), _c('th', [_vm._v("Время проверки")]), _vm._v(" "), _c('th', [_vm._v("E-mail")])])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', {
          attrs: {
            "width": "150"
          }
        }, [_vm._v(_vm._s(props.item.id) + " " + _vm._s(props.item.result === 'pass' ? "✅" : "❌") + " \n            "), _c('span', {
          staticStyle: {
            "font-size": "1.5em"
          }
        }, [_vm._v(" " + _vm._s(props.item.mail_check === '0' ? '📧' : '') + " ")])]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "150"
          }
        }, [_vm._v(_vm._s(props.item.nick_name))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "150"
          }
        }, [_vm._v(_vm._s(props.item.file_size))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.sender) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.received))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.dkim))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.spf))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.timestamp))]), _vm._v(" "), _c('td', [_c('a', {
          attrs: {
            "href": 'https://bankpdf.ru/mail/' + props.item.file + '.eml',
            "target": "_blank"
          }
        }, [_vm._v("Открыть")])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        })]
      }
    }])
  }, [_c('template', {
    slot: "no-data"
  }, [_c('span', [_c('p', {
    staticClass: "pt-2 blue--text subheading"
  }, [_c('v-icon', {
    staticClass: "blue--text",
    attrs: {
      "medium": ""
    }
  }, [_vm._v("info")]), _vm._v("Sorry, nothing to display here :(")], 1)])])], 2), _vm._v(" "), (_vm.isNotEmpty) ? _c('div', {
    staticClass: "text-xs-center pt-2"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pagination.pages,
      "total-visible": 10,
      "circle": ""
    },
    model: {
      value: (_vm.pagination.page),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "page", $$v)
      },
      expression: "pagination.page"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/vue-loader/lib/template-compiler?{"id":"data-v-cd40c922","hasScoped":false}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MailList.vue
// module id = 423
// module chunks = 0